import React, { useEffect, useState } from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AllProductEnquery = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [currentEnquiry, setCurrentEnquiry] = useState(null);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("");

  const fetchEnquiries = async () => {
    const sellerId = localStorage.getItem("seller_id");
    if (!sellerId) return;

    try {
      setLoading(true);
      const response = await axios.get(`${baseurl}getEnquiriesBySellerId/${sellerId}`);
      if (response.data?.data) setEnquiries(response.data.data);
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const openEditModal = (enquiry) => {
    setCurrentEnquiry(enquiry);
    setRemark(enquiry.sellerremark || "");
    setStatus(enquiry.sellerstatus || "");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentEnquiry(null);
    setRemark("");
    setStatus("");
  };

  const handleUpdate = async () => {
    if (!currentEnquiry?.id) return;
    try {
      await axios.post(`${baseurl}updateProductEnquirySeller`, {
        id: currentEnquiry.id,
        remark,
        status,
      });
      alert("Enquiry updated successfully!");
      closeModal();
      fetchEnquiries();
    } catch (error) {
      console.error("Error updating enquiry:", error);
      alert("Failed to update enquiry.");
    }
  };

  return (
    <>
      <SellerNavbar />
      <div className="container-fluid">
        <div className="row my-3 g-2">
          <div className="col-md-2">
            <SellerSidebar />
          </div>

          <div className="col-md-10">
            <div className="reviewcls text-start">
              <div className="row">
                <div className="col-md-6">
                  <h4 className="selh1">Product Enquiries</h4>
                </div>
              </div>

              <div className="card p-3 mt-3" style={{ overflowX: "auto" }}>
                {loading ? (
                  // 🔹 Skeleton loader for table
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Product Title</th>
                        <th>Remark</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array(5)
                        .fill()
                        .map((_, index) => (
                          <tr key={index}>
                            <td><Skeleton width={120} /></td>
                            <td><Skeleton width={160} /></td>
                            <td><Skeleton width={100} /></td>
                            <td><Skeleton count={2} width={200} /></td>
                            <td><Skeleton width={150} /></td>
                            <td><Skeleton width={100} /></td>
                            <td><Skeleton width={100} /></td>
                            <td><Skeleton width={140} /></td>
                            <td><Skeleton width={60} height={30} /></td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : enquiries.length === 0 ? (
                  <p>No enquiries found.</p>
                ) : (
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Product Title</th>
                        <th>Remark</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {enquiries.map((enquiry) => (
                        <tr key={enquiry.id}>
                          <td>{enquiry.name}</td>
                          <td>{enquiry.email}</td>
                          <td>{enquiry.phone}</td>
                          <td style={{ maxWidth: "200px", whiteSpace: "pre-wrap" }}>
                            {enquiry.message}
                          </td>
                          <td>{enquiry.title}</td>
                          <td>{enquiry.sellerremark || "-"}</td>
                          <td>{enquiry.sellerstatus || "-"}</td>
                          <td>{new Date(enquiry.created_at).toLocaleString()}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => openEditModal(enquiry)}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog" role="document" style={{ maxWidth: "500px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Enquiry</h5>
                <button type="button" className="btn-close" onClick={closeModal} />
              </div>
              <div className="modal-body text-start">
                <div className="mb-3">
                  <label htmlFor="remark" className="form-label">
                    Remark
                  </label>
                  <textarea
                    id="remark"
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    id="status"
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">-- Select Status --</option>
                    <option value="Pending">Pending</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Resolved">Resolved</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleUpdate}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AllProductEnquery;
